export const head = {
    styles: `
<style>
    /* BASIC RESET */
    html,
    body,
    body div,
    span,
    object,
    iframe,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    blockquote,
    pre,
    abbr,
    address,
    cite,
    code,
    del,
    dfn,
    em,
    img,
    ins,
    kbd,
    q,
    samp,
    small,
    strong,
    sub,
    sup,
    var,
    b,
    i,
    dl,
    dt,
    dd,
    ol,
    ul,
    li,
    fieldset,
    form,
    label,
    legend,
    table,
    caption,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td,
    article,
    aside,
    figure,
    footer,
    header,
    menu,
    nav,
    section,
    time,
    mark,
    audio,
    video,
    details,
    summary {
        margin: 0;
        padding: 0;
        border: 0;
        vertical-align: baseline;
    }

    main,
    article,
    aside,
    figure,
    footer,
    header,
    nav,
    section,
    details,
    summary {
        display: block;
    }

    html {
        box-sizing: border-box;
    }

    body {
        font-family: 'Arial Unicode MS', Arial, Helvetica, sans-serif;
        font-size: 13px;
        line-height: 1.16;
        letter-spacing: 0.4px;
    }

    .template-base {
        display: block;
        max-width: 740px;
        min-height: 100%;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-size: 24px;
        font-weight: normal;
        padding: 4px 0;
    }

    h2 {
        font-size: 22px;
    }

    h3 {
        font-size: 20px;
    }

    h4 {
        font-size: 18px;
    }

    h5 {
        font-size: 16px;
    }

    h6 {
        font-size: 14px;
    }

    blockquote {
        border-left: 4px solid #dddddd;
        padding-left: 15px;
    }

    p {
        padding: 4px 0;
    }

    a {
        color: #0066cc;
        text-decoration: none;
    }

    img {
        vertical-align: text-bottom;
    }

    hr {
        display: block;
        height: 1px;
        border: 0;
        border-top: 1px solid #ccc;
        margin: 4px 0;
        padding: 0;
    }

    small {
        font-size: 85%;
    }

    sub,
    sup {
        font-size: 75%;
        line-height: 0;
        position: relative;
    }

    sup {
        top: -4px;
    }

    sub {
        bottom: -2px;
    }

    .clearfix:after {
        content: " ";
        display: block;
        clear: both;
    }

    table {
        border-collapse: collapse;
        width: 100%;
        max-width: 740px !important;
        margin: 1px 0;
        table-layout: fixed;
    }

    td,
    th {
        padding: 2px 4px;
        border: 1px solid #cdcdcd;
        text-align: left;
        font-weight: normal;
        vertical-align: top;
    }

    th {
        font-weight: bold;
        vertical-align: middle;
    }

    td p,
    th p {
        margin: 0;
        padding: 0;
    }

    ul {
        margin: 0 10px;
        padding: 4px 10px;
    }

    ul li {
        list-style-type: disc;
    }

    ul li ul li {
        list-style-type: circle;
    }

    ul li ul li ul li {
        list-style-type: square;
    }

    ol {
        margin: 0 10px;
        padding: 4px 15px;
    }

    ol li {
        list-style-type: decimal;
    }

    ol li ol li {
        list-style-type: lower-alpha;
    }

    ol li ol li ol li {
        list-style-type: lower-alpha;
    }

    /* ******************
    * Print/PDF section
    ******************* */
        size: A4 portrait;
        margin: 60px 27px 60px 27px;
        font-family: 'Arial Unicode MS', Arial, sans-serif;

        @bottom-right {
            content: "[#if templateOriginCode?length gt 0][=templateOriginCode] |[/#if] strana " counter(page) " / " counter(pages);
            border-top: 1px solid #DDDDDD;
            font-size: 10px;
            color: #888888;
            font-family: 'Arial Unicode MS', Arial, sans-serif; 
        }

        @bottom-left {
            content: element(footer);
            border-top: 1px solid #DDDDDD;
            font-size: 10px;
            padding-top: 16px;
        }

        @top-center {
            content: element(header);
            font-size: 16px;
        }
    }

    #footer {
        position: running(footer);
        display: block;
        font-family: 'Arial Unicode MS', Arial, sans-serif;
        color: #888888;
        font-size: 12px;
        line-height: 14px;
        height: 60px;
    }

    #footer a {
        color: #0066cc;
        text-decoration: none;
    }

    #header {
        position: running(header);
        display: block;
        font-family: 'Arial Unicode MS', Arial, sans-serif;
        color: #333333;
        font-size: 14px;
        line-height: 16px;
        height: 55px;
        border-bottom: 1px solid #DDDDDD;
    }

    #header-left {
        padding-top: 5px;
        float: left;
        width: 50%;
    }

    #header-right {
        padding-top: 5px;
        float: left;
        text-align: right;
        width: 50%;
    }

    #header-clear {
        clear: left;
    }

    #header a {
        color: #0066cc;
        text-decoration: none;
    }

    table {
        -fs-table-paginate: paginate;
    }

    tr.iterator-body {
        page-break-inside: avoid;
        -fs-page-break-inside: avoid;
    }

    thead {
        display: table-header-group;
    }
</style>
`,
};
